module.exports = __webpack_public_path__ + "img/pawchi.9ff191f4.svg";